import { Outlet, useNavigate, useParams } from "react-router-dom";
import FlexCenter from "shared/components/Layout/components/FlexCenter";
import FlexColumn from "shared/components/Layout/components/FlexColumn";
import PrimaryButton from "shared/components/PrimaryButton";
import Switcher from "shared/components/Switcher";
import { BrandSettingsPageProvider, useBrandSettingsPage } from "./context";
import { getBrandSettingsColumns } from "./helpers";
import { SettingsTabs } from "./types";
import LanguagesView from "./views/LanguagesView";
import MaintenanceModeView from "./views/MaintenanceModeView";
import SearchView from "./views/SearchView";

const SettingsTab = () => {
  return (
    <BrandSettingsPageProvider>
      <SettingsTabContent />
    </BrandSettingsPageProvider>
  );
};

const SettingsTabContent = () => {
  const { id } = useParams();
  const brandId = String(id);
  const navigate = useNavigate();
  const {
    data,
    columnsParams,
    isLoadingPages,
    settingsTab,
    setSettingsTab,
    isLoadingAssistants,
    handleAddNewLanguage,
    languageDetailsDrawer,
  } = useBrandSettingsPage();

  const columns = getBrandSettingsColumns(
    columnsParams.handleOpenSettingDetailPage,
  );

  return (
    <FlexColumn gap="1rem" paddingTop="1rem">
      <FlexCenter justifyContent="space-between">
        <Switcher
          options={[
            { id: SettingsTabs.LANGUAGES, label: "Languages" },
            { id: SettingsTabs.SEARCH, label: "Search" },
            { id: SettingsTabs.MAINTENANCE_MODE, label: "Maintenance Mode" },
          ]}
          activeOptionId={settingsTab}
          onChange={(optionId) => {
            setSettingsTab(optionId as SettingsTabs);
          }}
        />
        {settingsTab === SettingsTabs.LANGUAGES && (
          <PrimaryButton
            title="Add new Language"
            size="small"
            loading={isLoadingAssistants}
            onClick={handleAddNewLanguage}
          />
        )}
      </FlexCenter>

      {settingsTab === SettingsTabs.SEARCH && (
        <SearchView
          data={data}
          columns={columns}
          isLoadingPages={isLoadingPages}
          navigate={navigate}
          brandId={brandId}
        />
      )}
      {settingsTab === SettingsTabs.LANGUAGES && (
        <LanguagesView languageDetailsDrawer={languageDetailsDrawer} />
      )}
      {settingsTab === SettingsTabs.MAINTENANCE_MODE && <MaintenanceModeView />}
      <Outlet />
    </FlexColumn>
  );
};

export default SettingsTab;
